<template>
  <div :class="success?'s4s-page':'s4s-page page-fail'" >
  <div v-if="success">
    <div class="s4s-detail">
      <div class="s4s-detail-header">
        <img src="../assets/icon/success.png" class="s4s-detail-header-icon" />
        <div >
          <div class="s4s-detail-header-title" >支付成功</div>
          <div class="s4s-detail-header-content" >违章预计1-5个工作日办理完成。</div>
        </div>
      </div>
      <div class="s4s-detail-body">
        <div class="s4s-illegal-list-body"  style="background:#fff;padding-bottom:15px;" >
            <div class="s4s-illegal-bd">
                <div class="s4s-illegal-bd-number">
                  <div class="s4s-origin">扣
                    <span style="color:#FFAF30">{{illegal.Point || 0}}</span>分</div>
                  <div class="s4s-origin">罚款
                    <span style="color:#FFAF30">{{illegal.Fine || 0}}</span>元</div>
                </div>
                <div class="s4s-illegal-bd-txt">{{illegal.Reason || '未知'}}</div>
                <div class="s4s-illegal-time">{{illegal.btr_time || '-'}}</div>
            </div>
        </div>
      </div>
    </div>
    <div class="s4s-detail-btn-container" >
      <button class="s4s-btn" bind:tap="gotoDetail">订单详情</button>
      <div style="width: 15px;"></div>
      <button class="s4s-btn" bind:tap="back" :style="{backgroundImage:advertisingShow.backgroundImage}">返回首页</button>
    </div>
    <div class="s4s-copyright">
      <div>本服务由<span @click="gotoMys4s" class="blue">齐车大圣</span>提供，客服电话：
          <span class="s4s-copyright-phone"  bind:tap="makePhoneCall" >0571-26281166</span>
      </div>
    </div>
  </div>
  <div v-if="!success">
    <div class="s4s-detail">
      <div class="s4s-detail-header">
        <img src="../assets/icon/fail.png" mode="aspectFit" class="s4s-detail-header-icon" />
        <div >
          <div class="s4s-detail-header-title" >{{text[0]}}</div>
          <div class="s4s-detail-header-content" >{{text[1]}} {{illegal.Time}} </div>
        </div>
      </div>
      <div class="s4s-detail-body">
        <div class="s4s-illegal-list-body" style="background:#fff;padding-bottom:15px;">
            <div class="s4s-illegal-bd" style="width:100%;">
              <div class="s4s-illegal-hd">
                  <img class="s4s-illegal-icon" mode="scaleToFill" src="../assets/icon/loc.png" />
                  <span class="s4s-illegal-addr">{{illegal.Address || '未知'}}</span>
              </div>
              <div class="s4s-illegal-bd-number">
                  <div class="s4s-origin"><span style="margin-right: 10px;">
                    扣<span style="color:#FFAF30">{{illegal.Point || 0}}</span>分</span>
                     罚款<span style="color:#FFAF30">{{illegal.Fine || 0}}</span>元</div>
              </div>
              <div class="s4s-illegal-bd-txt" style="height:auto;">{{illegal.Reason || '未知'}}</div>
              <div class="s4s-illegal-time">{{illegal.btr_time || '-'}}</div>
            </div>
        </div>
      </div>
    </div>
    <div class="s4s-pay-body">
        <div class="s4s-group">
          <span class="s4s-group-tit">订单号码</span>
          <span class="s4s-group-txt">{{ illegal.SwiftNum  || '-' }}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">创建时间</span>
          <span class="s4s-group-txt">{{ illegal.CreateTime  || '-'}}</span>
        </div>
       <div class="s4s-group">
          <span class="s4s-group-tit">手机号码</span>
          <span class="s4s-group-txt">{{ illegal.mobile  || '-'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">车牌号码</span>
          <span class="s4s-group-txt">{{ illegal.car_no  || '-'}}</span>
        </div>
        <div class="s4s-group" v-if=" illegal.drive_no">
          <span class="s4s-group-tit">驾驶证号</span>
          <span class="s4s-group-txt">{{ illegal.drive_licence_num }}</span>
        </div>
        <div class="s4s-group group-upload"
        v-if=" illegal.drive_licence || illegal.travel_licence "
        style="padding: 20px 0;">
          <span class="s4s-group-tit">行驶证</span>
          <div style="display: flex;flex: 1;align-items: center;">
              <img v-if="illegal.drive_licence"
              :src="illegal.drive_licence"
              style="width: 90px;height: 70px;margin: 5px 0;" bind:tap="viewDrive" />
              <img v-if="illegal.travel_licence"
              :src="illegal.travel_licence"
              style="width: 90px;height: 70px;margin: 5px 0 5px 10px;" bind:tap="viewDrive" />
          </div>
        </div>
        <div class="s4s-group group-upload"
        v-if="illegal.jsz_drive_licence ||  illegal.jsz_travel_licence " style="padding: 20px 0;">
          <span class="s4s-group-tit">驾驶证</span>
          <div style="display: flex;flex: 1;align-items: center;">
              <img v-if="illegal.jsz_drive_licence"
              :src="illegal.jsz_drive_licence"
              style="width: 90px;height: 70px;margin: 5px 0;" bind:tap="viewDrive" />
              <img v-if="illegal.jsz_travel_licence"
              :src="illegal.jsz_travel_licence"
              style="width: 90px;height: 70px;margin: 5px 0 5px 10px;" bind:tap="viewDrive" />
          </div>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">罚款金额</span>
          <span class="s4s-group-txt">￥ {{ illegal.Fine || '0.00' }}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">服务费用</span>
          <span class="s4s-group-txt"
          style="color:#FFAF30;" >￥ {{ illegal.OwnFree || '0.00' }}</span>
        </div>
        <div v-if="illegal.Urge" class="s4s-group">
          <span class="s4s-group-tit">加急费用</span>
          <span class="s4s-group-txt">
            ￥ {{ illegal.UrgeFee || '0.00'}}
          </span>
        </div>
    </div>
        <div class="s4s-pay" v-if="pay">
          <div class="s4s-pay-container">
            <div class="s4s-pay-btn" >
                <div class="s4s-pay-text">合计金额：
                  <span style="color:#fd2900;font-weight: bold;">
                    ￥ {{ illegal.TotalPrice || '0.00' }}
                    </span></div>
                <div class="s4s-pay-tip">预计1-5个工作日办理完成 </div>
            </div>
            <div class="s4s-pay-btn" data-item="illegal" data-id="illegal.id" catch:tap="bindPay" :style="{backgroundImage:advertisingShow.backgroundImage}">
                立即办理
            </div>
        </div>
  </div>

</div>

</div>
</template>

<script>
import advertisingShow from './../utils/advertising';

export default {
  name: 'success1',
  data() {
    return {
      orderId: 0,
      success: true,
      illegal: {},
      text: ['', ''],
      data: {},
      count: 0,
      pay: false,
      advertisingShow: advertisingShow(),
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '支付结果'
      });
    }
    if (!this.userInfo) {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: '/user',
        },
      });
    } else {
      const { orderId } = this.$route.query;
      this.orderId = orderId;
      this.getDetail(orderId);
    }
  },
  methods: {
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', 's1','','']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    selectText(num) {
      switch (num) {
        case 0:
          return ['订单待支付', '订单剩余可支付时间'];
        case 11:
          return ['订单待支付', '订单剩余可支付时间'];
        case 2:
          return ['订单已取消', '该订单已取消，请重新下单'];
        case 3:
          return ['支付成功', '恭喜您支付成功，订单正在处理中...'];
        case 7:
          return ['订单已完成', '违章已在交管系统销网成功，外网查询存在延时。请以交管系统查询结果为准'];
        case 8:
          return ['订单已完成', '违章已在交管系统销网成功，外网查询存在延时。请以交管系统查询结果为准'];
        case 5:
          return ['处理失败已退款', '处理失败已退款,24小时内原路退回所缴款项'];
        case 6:
          return ['处理失败已退款', '处理失败已退款,24小时内原路退回所缴款项'];
        case 1:
          return ['处理失败已退款', '处理失败已退款,24小时内原路退回所缴款项'];
        case 10:
          return ['处理失败已退款', '处理失败已退款,24小时内原路退回所缴款项'];
        default:
          return ['正在同步订单信息，', `请稍等${this.returnCount()}`];
      }
    },
    returnCount() {
      return Array.from({ length: (this.data.count % 3) + 1 }).fill('.').join('');
    },
    getDetail(id) {
      const self = this;
      clearTimeout(self.data.timer);
      this.$request('v3/violation/order/info', { order_id: id }).then((xhr, res) => {
        if (res.code === 0) {
          const { data } = res;
          // data.Status = 3
          const setD = {
            illegal: data,
            text: self.selectText(null),
          };
          if (data.Status === 0 && self.data.count < 10) {
            const timer = setTimeout(() => {
              self.getDetail(id);
            }, 1000);
            self.setData({
              timer,
              count: self.data.count + 1,
            });
          } else {
            self.getAd();
            setD.success = data.Status === 3;
            setD.pay = data.Status === 11 || data.Status === 0;
            setD.text = self.selectText(data.Status);
            if (data.Status === 11 || data.Status === 0) {
              data.Time = `${parseInt(((new Date(data.CreateTime.replace(new RegExp('-', 'g'), '/')).valueOf() + 0.5 * 60 * 60 * 1000) - new Date().valueOf()) / 1000 / 60)}分钟`;//eslint-disable-line
            }
          }
          if (!data.Address.trim()) {
            data.Address = '未知';
          }
          if (data.Urge) {
            data.UrgeFee = (
              (data.TotalPrice - data.Fine - data.OwnFree - data.late_free) / 100 || 0
            ).toFixed(2);
          }
          if (data.Fine) {
            data.Fine = (data.Fine / 100).toFixed(2);
          }
          if (data.OwnFree) {
            data.OwnFree = (data.OwnFree / 100).toFixed(2);
          }
          if (data.late_free) {
            data.late_free = (data.late_free / 100).toFixed(2);
          }
          if (data.TotalPrice) {
            data.TotalPrice = (data.TotalPrice / 100).toFixed(2);
          }
          this.illegal = setD.illegal;
          this.text = setD.text;
        } else {
          this.$showToast({
            icon: 'none',
            title: res.msg, // 文字内容
          });
        }
      });
    },
    gotoDetail() {
      this.$router.replace({
        path: `../detail1/detail1?orderId=${this.data.orderId}`, // 需要跳转的 tabBar 页面的路径（需在 app.json 的 tabBar 字段定义的页面），路径后不能带参数
      });
    },
    back() {
      this.$router.push({
        path: '/', // 需要跳转的 tabBar 页面的路径（需在 app.json 的 tabBar 字段定义的页面），路径后不能带参数
      });
    },
    // 在线支付
    bindPay(item) {
      const { id } = item;
      const param = {
      // oid: id
        order_id: id,
      };
      // v2 参数是oid   v3是order_id
      // v2/car/vio_pay_order
      this.$request('v3/violation/web/order/repay', param).then((xhr, res) => {
        if (res.code > 0) {
          this.$showToast({
            icon: 'none',
            title: res.msg,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-fail {
  background-image: url(../assets/icon/bg_fail.png);
}
.s4s-detail-btn-container {
  display: flex;
  margin-bottom: 12px;
  margin-top: 40px;
}
.s4s-btn {
  flex: 1;
}
.s4s-btn:first-child {
  color: #3A82FF;
  border: 1px solid #3A82FF;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
}
.s4s-page {
  background-image: url(../assets/icon/bg_suc.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: -2px;
}
</style>

